module.exports = __webpack_public_path__ + "static/media/img-manner-tel.f6d752db.svg";